<template>
   <v-card
        light
        elevation="1"
        class="d-flex justify-center align-center flex-column"
        :style="$vuetify.breakpoint.width>1000?'padding: 50px 30px; ':'padding: 50px 0px;'"
        style="height: 100%;"
        :key="selfKey"
    >
        <div class="d-flex justify-center align-center" style="width: 100%; margin-bottom: 30px;">
            <v-card-title v-if="type=='create'" class="text-h4 font-weight-medium">Create User</v-card-title>
            <v-card-title v-else class="text-h4 font-weight-medium">Edit User</v-card-title>
        </div>
        <div style="width: 80%;">
            <div class="d-flex flex-row align-baseline">
                <div
                style="width: 70%;">
                    <v-text-field
                        v-model="email"
                        label="Email"
                        persistent-placeholder
                        clearable
                        prepend-icon="mdi-email"
                        :error-messages="message"
                        :rules="emailRules"
                        :disabled="chkEmailDup || type=='edit'"
                        @keypress.enter="emailvalidation"
                    ></v-text-field>
                </div>
                    <v-btn outlined small :disabled="!isEValid" v-if="!chkEmailDup && type=='create' " color="blue-grey darken-2" @click="emailvalidation" style="margin-left: 10px;">
                        check
                    </v-btn>
                    <v-btn 
                        icon 
                        small 
                        color="green darken-3" 
                        v-if="chkEmailDup  && type=='create'" 
                        style="margin-left: 10px;"  
                    >
                        <img class="checkBtn" src="@/assets/check.svg">
                    </v-btn>

            </div>

            <div style="width:70%">
                <v-text-field
                    v-model="username"
                    :rules="[() => !!username && username.trim().length > 0 || 'Username is required',]"
                    label="Username"
                    persistent-placeholder
                    clearable
                    prepend-icon="mdi-account"
                ></v-text-field>
            </div>
            <div style="width: 70%;" v-if="type=='create'">
                <v-text-field
                    v-model="password"
                    label="Password"
                    :rules=pwdRules
                    persistent-placeholder
                    clearable
                    prepend-icon="mdi-lock"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    :type="show1 ? 'text' : 'password'"
                    @input="pwdValidation"
                ></v-text-field>
            </div>
            <div style="width: 70%;" v-else>
                <v-text-field
                    v-model="password"
                    label="Password"
                    :rules=pwdRules1
                    persistent-placeholder
                    clearable
                    prepend-icon="mdi-lock"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    :type="show1 ? 'text' : 'password'"
                    @input="pwdValidation"
                ></v-text-field>
            </div>
            <div id="vSelect" style="width: 30%; padding-left: 30px; margin-top: 10px; height: 50px;">
                <template>
                    <v-select
                    v-model="group"
                    :items="items"
                    class="groupSelect"
                    label="Group"
                    hide-details
                    dense
                    ></v-select>
                </template>
            </div>
            <div class="d-flex align-center flex-row" style="gap: 5px;">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="date1"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date1"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="date1"
                    no-title
                    scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="menu1 = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(date1)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
                <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date2"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    id="endDate"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date2"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="date2"
                    no-title
                    scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="menu2 = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(date2)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
            <div 
                class="d-flex justify-center"
                style="gap: 5px; margin-top: 20px;"
                :style="$vuetify.breakpoint.width<600?'width:90%;':''"
            >
                <v-btn small elevation="" outlined color="error" @click="closePopup">
                    cancel
                </v-btn>
                <v-btn v-if="type=='create'" style="width: 80px;" small elevation="" :disabled="!isActive" outlined color="green darken-3" @click="createUser">
                    create
                </v-btn>
                <v-btn v-else small elevation="" :disabled="!isActive1" style="width: 80px;" outlined color="green darken-3" @click="editUser">
                    Edit
                </v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>
import EventBus from '@/plugins/EventBus';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: 'userCreate',
       data:()=>({
        selfKey:0,
        email:null,
        show1: false,
        show2: false,
        username:null,
        password:null,
        chkEmailDup:false,
        chkPwd:false,
        isCheckBtn:true,
        isEmailChecked: false,
        isActive:false,
        isActive1:true,
        emailRules: [
            v => !!v || 'Email is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        pwdRules:[
            (v) => !!v || "Password is required",
            (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
            (v) => (v && v.trim().length > 0) || "Passwords must be valid",
            (v) => (v && /[!@#$%^&*(),.?":{}|<>]/.test(v)) || "Password must contain at least one special character",
            (v) => (v && /\d/.test(v)) || "Password must contain at least one number"
        ],
        pwdRules1:[
            (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
            (v) => (v && v.trim().length > 0) || "Passwords must be valid",
            (v) => (v && /[!@#$%^&*(),.?":{}|<>]/.test(v)) || "Password must contain at least one special character",
            (v) => (v && /\d/.test(v)) || "Password must contain at least one number"
        ],
        message: null,
        items:['Admin','User', 'Viewer'],
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        modal: false,
        group: null,
    }),
    props:{
        type:String,
        userData: Number
    },
    created(){
        console.log(this.isActive1)
        if(this.type == 'edit'){
            console.log(this.userData)
            this.chkPwd = true
            axios.post(`${this.$apiUrl}/manage/user`,{
                user_id: this.userData
            },{
                withCredentials: true
            }).then((res)=>{
                console.log(res)
                this.email = res.data.email;
                this.group = res.data.group;
                this.username = res.data.username;
                this.date1 = this.fomatDate(res.data.user_start_date);
                this.date2 = this.fomatDate(res.data.user_expire_date);
            })
        }else{
            console.log(this.type)
            this.date1 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            const date = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000);
            date.setMonth(date.getMonth()+3);
            this.date2 = date.toISOString().substr(0, 10);
        }
    },
    computed:{
        isEValid(){
            return this.emailRules.every(rule=>rule(this.email)===true);
        }
    },
    watch:{
        chkEmailDup:{
            handler(){
                this.checkAllFilled();
            },
            immediate:true
        },
        username:{
            handler(){
                this.checkAllFilled();
            },
            immediate:true
        },
        chkPwd:{
            handler(){
                this.checkAllFilled();
            },
            immediate:true
        },
        email() {
            this.isEmailChecked = false;
            this.chkEmailDup = false;
            this.isEmailValid = true;
            this.message = null;
        },
        date1:{
            handler(){
                this.checkAllFilled();
            },
            immediate:true
        },
        date2:{
            handler(){
                this.checkAllFilled();
            },
            immediate:true
        },
        group:{
           handler(){
                this.checkAllFilled();
            },
            immediate:true 
        }
        
    },
    methods:{
        checkAllFilled:function(){
            if(this.type=='create'){
                if(this.chkEmailDup && this.username!==null && this.chkPwd && this.date1 !==null && this.date2 !==null && this.group !==null){
                    this.isActive=true;
                }else{
                    this.isActive=false;
                }
            }else{
                if(this.username !==null && this.chkPwd && this.date1 !==null && this.date2 !==null && this.group !==null){
                    this.isActive1 = true;
                }else{
                    this.isActive1 = false;
                }
            }
        },
        emailvalidation:function(){
            if(this.isEValid){
                axios.post(`${this.$apiUrl}/user/chkemaildup`,{
                    email:this.email
                },{
                withCredentials: true
                }).then((res)=>{
                    this.isEmailChecked = true;
                    // console.log(res);
                    if(!res.data.dup_email){ // 이메일이 중복되지 않은 경우
                        this.chkEmailDup=true;
                        this.message = null;
                    }else{ // 이메일이 중복된 경우
                        this.chkEmailDup=false;
                        this.isCheckBtn=false;
                        this.message = 'This email is duplicated'
                    }
                })
            }else{
                console.log("email check");
            }
        },
        pwdValidation:function(){
            if(this.type=='create'){
                if(this.password.length < 8 || !/[!@#$%^&*(),.?":{}|<>]/.test(this.password)|| !/\d/.test(this.password)){
                    this.chkPwd = false;
                }else{
                    this.chkPwd = true;
                }
            }else{
                if(this.password == null || this.password.length==0){ 
                    this.chkPwd = true;
                }else if(this.password.length>0 && this.password.length < 8){
                    this.chkPwd = false;
                }else if(this.password.length>=8){
                    if(/[!@#$%^&*(),.?":{}|<>]/.test(this.password) && /\d/.test(this.password)){
                        this.chkPwd = true;
                    }
                }
            }
            // if(this.chkPassword!=null && this.chkPassword.trim().length > 0){

            //     if(this.password !=this.chkPassword){
            //         this.chkPwd=false;
            //         return 'Password do not match';

            //     }else if(this.password !=this.chkPassword ||
            //      this.password.length < 8 || 
            //      !/[!@#$%^&*(),.?":{}|<>]/.test(this.password)||
            //      !/\d/.test(this.password)
            //     ){
                
            //         this.chkPwd=false;
            //         return false;
            //     }else{
            //         this.chkPwd = true;
            //         return true;
            //     }
            // }else{
            //     this.chkPwd=false;
            //     return 'Check Password is required';
            // }
            
        },
        createUser:function(){
            console.log("user create")
            axios.post(`${this.$apiUrl}/manage/create`,{
                id: this.username,
                pw: this.password,
                email: this.email,
                group: this.group,
                start_time: this.date1,
                end_time: this.date2
            },{
                withCredentials: true
            }).then((res)=>{
                console.log(res);
                if(res.data.result){
                    console.log("create finish")
                    Swal.fire({
                        title: 'User created successfully.',
                        text: "The created user can be found in the 'User Management' menu.",
                        icon: 'success',
                        width: '400px',
                        confirmButtonText:'OK',
                        confirmButtonColor: '#4CAF50',
                        customClass:{
                            confirmButton: 'custom-confirm-button'
                        }
                    }).then(()=>{
                        // this.$router.go();
                        EventBus.$emit('createClose')
                    })

                }
            })
        },
        fomatDate(string){
            const date = new Date(string);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
            const dd = String(date.getDate()).padStart(2, '0');
            return string? `${yyyy}-${mm}-${dd}`: '-';
        },
        editUser:function(){
            axios.post(`${this.$apiUrl}/manage/modify`,{
                user_id: this.userData,
                username: this.username,
                user_start_date: this.date1,
                user_expire_date: this.date2,
                group: this.group,
                newPw: this.password
            },{
                withCredentials: true
            }).then((res)=>{
                if(res.data.result){
                    console.log("edit finish")
                    Swal.fire({
                        title: 'Successfully updated.',
                        text: "The updated user can be found in the 'User Management' menu.",
                        icon: 'success',
                        width: '400px',
                        confirmButtonText:'OK',
                        confirmButtonColor: '#4CAF50',
                        customClass:{
                            confirmButton: 'custom-confirm-button'
                        }
                    }).then(()=>{
                         EventBus.$emit('createClose')
                    })
                }
            })
        },
        closePopup:function(){
            EventBus.$emit('createClose')
        }
    }
}
</script>

<style>
.v-overlay__content{
    width: 70%;
}

.checkBtn{
    filter: invert(39%) sepia(11%) saturate(2527%) hue-rotate(73deg) brightness(99%) contrast(91%);
}

.mdi-close{
    opacity: 0 !important;
    pointer-events: none;
}

#dropdownImg{
    width: 20px;
}

.v-list-item{
    min-height: 0px !important;
    padding: 5px 10px;

}
@media (max-width:600px){
 .v-menu__content{
    left: 30% !important;
  } 
}

@media (max-width:500px){
 .v-menu__content{
    left: 10% !important;
  } 

  .v-picker__body{
    width: 100% !important;
  }

  .v-data-footer{
    margin-right: 0px !important;
    justify-content: center !important;
  }

  .v-data-footer__select{
    display: none !important;
  }
}

</style>